"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_sanofi/cssConstants.js"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _UrlNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/UrlNugget"));

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _KESI2Helper = _interopRequireWildcard(require("../../../../KESI2/KESI2Helper"));

var _Spinner = _interopRequireDefault(require("../../Spinner/Spinner"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _DownloadHelper = _interopRequireDefault(require("../../../../helpers/DownloadHelper"));

var _TimeoutHelper = require("../../../../helpers/TimeoutHelper");

var _ArrayHelper = require("../../../../helpers/ArrayHelper");

var _PDF = require("../../../../utils/PDF");

var _GeolocationHelper = _interopRequireDefault(require("../../../../helpers/GeolocationHelper"));

var _MuiAlertHelper = require("../../../../helpers/MuiAlertHelper");

var _DrupalUrlNuggetStrings = require("./DrupalUrlNuggetStrings");

var _NavigationManagerCordova = _interopRequireDefault(require("../../../NavigationManagerCordova"));

var _CordovaFileHelper = _interopRequireWildcard(require("../../../../helpers/CordovaFileHelper"));

var _FileReaderWriterWrapper = _interopRequireDefault(require("../../../../cordovaPluginWrappers/FileReaderWriterWrapper"));

var _RegisterInstance = _interopRequireDefault(require("../../../../KESI2/Services/RegisterInstance"));

var _KeyboardHelper = require("../../../../helpers/KeyboardHelper");

var _DrupalUrlNugget = _interopRequireDefault(require("./DrupalUrlNugget.scss"));

var _FileTransferWrapper = _interopRequireDefault(require("../../../../cordovaPluginWrappers/FileTransferWrapper"));

var _CordovaHelper = require("../../../../helpers/CordovaHelper");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'urlContainer_';
var IFRAME_TIME_TO_WAIT_ON_BACK = 3000;
var IFRAME_LOADING_TIME_1 = 3000;
var IFRAME_LOADING_TIME_2 = 10000;
var GEO_WATCH_ID = 42;

var shouldAddMessageListener = function shouldAddMessageListener(nugget) {
  return nugget.kesiToolsActive && !nugget.openInWebview;
};

var DrupalUrlNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalUrlNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalUrlNugget);

  function DrupalUrlNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalUrlNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getCurrentGeoLocation", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var location,
          flexLink,
          nugget,
          geolocation,
          _geolocation,
          _args = arguments;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              location = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
              flexLink = _this.props.flexLink;
              nugget = _this.getNugget(_this.props, _this.state);

              if (flexLink && flexLink.indexOf('<Location>') !== -1 || nugget.src && nugget.src.indexOf('<Location>') !== -1) {
                if (location) {
                  geolocation = location;
                  console.log('warning location', geolocation);

                  _this.setState({
                    currentGeoLocation: geolocation
                  });
                } else {
                  _geolocation = window.navigator.geolocation.SafetureLocation;
                  console.log('currentGeoLocation', _geolocation);

                  _this.setState({
                    currentGeoLocation: _geolocation
                  });
                }
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getIframeId", function () {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.id;
      return "".concat(DOM_PREFIX).concat(id, "_iframe");
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onLoaded", function () {
      console.log('iframe loaded (DrupalUrlNugget)');
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getSavedValuesForIframe", function () {
      console.log('getSavedValuesForIframe');

      var nugget = _this.getNugget(_this.props, _this.state);

      var values = {};

      if (nugget.savedDataKeys) {
        nugget.savedDataKeys.forEach(function (key) {
          values[key] = _DataStore["default"].getElementByPathImmediately(_this.getDataStorePathForKey(key));
        });
      }

      console.log('getSavedValuesForIframe', values);
      return values;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setIframeValues", function (keysValues) {
      // only save those values that are in nugget.savedDataKeys
      var nugget = _this.getNugget(_this.props, _this.state);

      if (!nugget.savedDataKeys) {
        return;
      }

      var values = {};
      (0, _keys["default"])(keysValues).filter(function (key) {
        return nugget.savedDataKeys.indexOf(key) >= 0;
      }).forEach(function (key) {
        values[_this.getDataStorePathForKey(key)] = keysValues[key];
      });

      _DataStore["default"].setData(values);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onBack", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.sendCommandToIframe({
                command: 'back'
              });

              _this.backTimer = setTimeout(function () {
                _this.callDefaultBack();
              }, IFRAME_TIME_TO_WAIT_ON_BACK);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "openPDF", function (filename) {
      (0, _PDF.openPDF)(filename);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "openInternalId", function (id) {
      console.log('openInternalId', id, (0, _typeof2["default"])(id));

      if (id) {
        var path = _KESI2Helper["default"].getPathToContentInTree(id.toString());

        console.log('openInternalId', path);

        if (path) {
          _NavigationManagerCordova["default"].goTo("kesi2/".concat(path.join('!')));
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "downloadInBrowser", function (url) {
      window.open(url, '_system');
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "camera", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var image;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setTimeout(function () {
                _this.urlRef.hide();
              }, 200);
              _context3.next = 3;
              return (0, _CordovaHelper.takePictureWithCamera)(null, null);

            case 3:
              image = _context3.sent;

              _this.sendCommandToWebview({
                command: 'image',
                payload: 'data:image/jpeg;base64,' + image
              });

              _this.urlRef.show();

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "gallery", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var image;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setTimeout(function () {
                _this.urlRef.hide();
              }, 200);
              _context4.next = 3;
              return (0, _CordovaHelper.takePictureFromGallery)(null, null);

            case 3:
              image = _context4.sent;

              _this.sendCommandToWebview({
                command: 'image',
                payload: 'data:image/jpeg;base64,' + image
              });

              _this.urlRef.show();

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "shareContent", function (payload) {
      var _window$plugins;

      if (((_window$plugins = window.plugins) === null || _window$plugins === void 0 ? void 0 : _window$plugins.socialsharing) && payload.data) {
        var options = {
          // message: 'Mein ERGO Leitbild teilen', // not supported on some apps (Facebook, Instagram)
          subject: 'Mein ERGO Leitbild',
          // fi. for email
          files: [payload.data],
          // an array of filenames either locally or remotely
          chooserTitle: 'Wähle eine App zum Teilen:' // Android only, you can override the default share sheet title

        };

        var onError = function onError(msg) {
          return console.log('Sharing failed with message: ' + msg);
        };

        var onSuccess = function onSuccess(msg) {
          console.log('Sharing successful with message: ' + msg);

          if (payload.preview) {
            _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.ERGOPRO_STATEMENT_PIC, payload.preview);
          }
        };

        window.plugins.socialsharing.shareWithOptions(options, onSuccess, onError);
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkScopes", function (scopes) {
      if (typeof scopes === 'undefined' || !scopes || scopes.length === 0) {
        return false;
      }

      var nugget = _this.getNugget(_this.props, _this.state);

      if (!nugget.scopes) {
        return false;
      }

      var singleScopes = scopes.split(' ');

      if (singleScopes.length > 0) {
        var allowed = singleScopes.find(function (scope) {
          return !nugget.scopes.match(scope);
        });
        return typeof allowed === 'undefined';
      }

      return true;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "downloadPDF", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(downloadableSrc) {
        var downloadFolder, online, onProgress, pdfName;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                console.log('downloadPDF');
                _context5.next = 3;
                return _CordovaFileHelper["default"].getDownloadFolder();

              case 3:
                downloadFolder = _context5.sent;
                console.log('downloadFolder exists ? ', downloadFolder);
                online = _DeviceInfoHelper["default"].isOnline();

                if (online) {
                  _context5.next = 10;
                  break;
                }

                console.log('downloadPDF not online');
                (0, _MuiAlertHelper.showWideAlertHtml)((0, _DrupalUrlNuggetStrings.getString)('OFFLINE_TEXT'), (0, _DrupalUrlNuggetStrings.getString)('OFFLINE_TITLE'));
                return _context5.abrupt("return");

              case 10:
                _context5.prev = 10;

                onProgress = function onProgress(evt) {// if (!evt || !evt.loaded || !evt.total) {
                  //   console.error('unexpected progress event')
                  //   this.setProgress(-1)
                  //   return
                  // }
                  //
                  // const progressPercent = Math.floor((evt.loaded / evt.total) * 100)
                  //
                  // this.setProgress(progressPercent)
                };

                pdfName = 'statement_img';
                _context5.next = 15;
                return new _FileTransferWrapper["default"]().downloadWithJS(downloadableSrc, pdfName, downloadFolder.name, onProgress, true);

              case 15:
                console.log('downloadPDF4 finished');
                _context5.next = 21;
                break;

              case 18:
                _context5.prev = 18;
                _context5.t0 = _context5["catch"](10);
                console.error('error downloading video', _context5.t0);

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[10, 18]]);
      }));

      return function (_x) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onReceiveMessage", /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(evt, json) {
        var data, title, consumed, scopes, callbackId, allowed, authToken, keyboardEvent;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log('onReceiveMessage', evt, json);
                _context6.prev = 1;

                // any message (even empty) means that the iFrame is loaded
                if (_this.iframeLoadingTimer) {
                  clearTimeout(_this.iframeLoadingTimer);
                  _this.iframeLoadingTimer = null;
                }

                if (_this.state.isLoading) {
                  _this.setState({
                    isLoading: false
                  });
                }

                console.log('onReceiveMessage2', evt, json);
                data = (json === null || json === void 0 ? void 0 : json.data) || JSON.parse(evt.data);
                console.log('got message from iframe:', data, json);
                _context6.t0 = data.command;
                _context6.next = _context6.t0 === 'alive' ? 10 : _context6.t0 === 'setTitle' ? 12 : _context6.t0 === 'backCallback' ? 15 : _context6.t0 === 'getAuthToken' ? 19 : _context6.t0 === 'hideKeyboard' ? 38 : _context6.t0 === 'openInSystemBrowser' ? 41 : _context6.t0 === 'downloadPDF' ? 43 : _context6.t0 === 'loadValues' ? 45 : _context6.t0 === 'setValues' ? 47 : _context6.t0 === 'getGeolocation' ? 49 : _context6.t0 === 'openPDF' ? 51 : _context6.t0 === 'openInternalId' ? 53 : _context6.t0 === 'camera' ? 55 : _context6.t0 === 'gallery' ? 57 : _context6.t0 === 'share' ? 59 : _context6.t0 === 'downloadFile' ? 61 : _context6.t0 === 'deleteFile' ? 63 : _context6.t0 === 'scrollToTop' ? 65 : 67;
                break;

              case 10:
                _this.setIframeLoaded();

                return _context6.abrupt("break", 67);

              case 12:
                title = data.value;

                if (title) {
                  _this.props.setTitle(title);
                }

                return _context6.abrupt("break", 67);

              case 15:
                if (_this.backTimer) {
                  clearTimeout(_this.backTimer);
                  _this.backTimer = null;
                }

                consumed = data.consumed;

                if (!consumed) {
                  _this.callDefaultBack();
                }

                return _context6.abrupt("break", 67);

              case 19:
                scopes = data.scopes;
                callbackId = data.callbackId; // check scopes if in scopes of drupal

                allowed = _this.checkScopes(scopes);

                if (allowed) {
                  _context6.next = 26;
                  break;
                }

                _this.sendCommandToIframe({
                  command: 'authTokenFailed',
                  error: 'Scopes not allowed',
                  callbackId: callbackId
                });

                _context6.next = 37;
                break;

              case 26:
                if (!scopes) {
                  _context6.next = 37;
                  break;
                }

                _context6.prev = 27;
                _context6.next = 30;
                return _RegisterInstance["default"].getAccessToken(scopes);

              case 30:
                authToken = _context6.sent;

                if (authToken) {
                  _this.sendCommandToIframe({
                    command: 'authToken',
                    authToken: authToken,
                    callbackId: callbackId
                  });
                } else {
                  _this.sendCommandToIframe({
                    command: 'authTokenFailed',
                    error: 'No access',
                    callbackId: callbackId
                  });
                }

                _context6.next = 37;
                break;

              case 34:
                _context6.prev = 34;
                _context6.t1 = _context6["catch"](27);

                _this.sendCommandToIframe({
                  command: 'authTokenFailed',
                  error: {
                    message: _context6.t1.message,
                    code: _context6.t1.code
                  },
                  callbackId: callbackId
                });

              case 37:
                return _context6.abrupt("break", 67);

              case 38:
                (0, _KeyboardHelper.hideKeyboard)(true);

                if (_DeviceInfoHelper["default"].isAndroid()) {
                  keyboardEvent = new window.CustomEvent('hideKeyboard');
                  document.dispatchEvent(keyboardEvent);
                }

                return _context6.abrupt("break", 67);

              case 41:
                window.open(data.url, '_system');
                return _context6.abrupt("break", 67);

              case 43:
                _this.downloadPDF(data.url);

                return _context6.abrupt("break", 67);

              case 45:
                _this.sendCommandToIframe({
                  command: 'savedValues',
                  savedValues: _this.getSavedValuesForIframe()
                });

                return _context6.abrupt("break", 67);

              case 47:
                _this.setIframeValues(data.values);

                return _context6.abrupt("break", 67);

              case 49:
                _this.sendGeolocationToIframe();

                return _context6.abrupt("break", 67);

              case 51:
                _this.openPDF(data.filename);

                return _context6.abrupt("break", 67);

              case 53:
                _this.openInternalId(data.url);

                return _context6.abrupt("break", 67);

              case 55:
                _this.camera();

                return _context6.abrupt("break", 67);

              case 57:
                _this.gallery();

                return _context6.abrupt("break", 67);

              case 59:
                _this.shareContent(data.payload);

                return _context6.abrupt("break", 67);

              case 61:
                _this.downloadFile(data.callbackId, data.url, data.localFilename, data.reload);

                return _context6.abrupt("break", 67);

              case 63:
                console.error('The function deleteFile is not yet implemented');
                return _context6.abrupt("break", 67);

              case 65:
                if (_DeviceInfoHelper["default"].isiOS()) {
                  window.scrollTo(0, 0);
                }

                return _context6.abrupt("break", 67);

              case 67:
                _context6.next = 72;
                break;

              case 69:
                _context6.prev = 69;
                _context6.t2 = _context6["catch"](1);
                // just go on
                console.error(_context6.t2);

              case 72:
                // any message received means the site is loaded
                _this.setState({
                  loaded: true
                });

              case 73:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[1, 69], [27, 34]]);
      }));

      return function (_x2, _x3) {
        return _ref6.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getInsetTop", function () {
      if (CSS.supports('padding-bottom: constant(safe-area-inset-top)')) {
        var div = document.createElement('div');
        div.style.paddingTop = 'constant(safe-area-inset-top)';
        document.body.appendChild(div);
        var calculatedPadding = (0, _parseInt2["default"])(window.getComputedStyle(div).paddingTop, 10);
        document.body.removeChild(div);
        return _cssConstants["default"].safeAreaTopDivisor ? calculatedPadding / _cssConstants["default"].safeAreaTopDivisor : calculatedPadding;
      }

      if (CSS.supports('padding-bottom: env(safe-area-inset-top)')) {
        var _div = document.createElement('div');

        _div.style.paddingTop = 'env(safe-area-inset-top)';
        document.body.appendChild(_div);

        var _calculatedPadding = (0, _parseInt2["default"])(window.getComputedStyle(_div).paddingTop, 10);

        document.body.removeChild(_div);
        return _cssConstants["default"].safeAreaTopDivisor ? _calculatedPadding / _cssConstants["default"].safeAreaTopDivisor : _calculatedPadding;
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getInsetBottom", function () {
      if (CSS.supports('padding-bottom: constant(safe-area-inset-bottom)')) {
        var div = document.createElement('div');
        div.style.paddingBottom = 'constant(safe-area-inset-top)';
        document.body.appendChild(div);
        var calculatedPadding = (0, _parseInt2["default"])(window.getComputedStyle(div).paddingBottom, 10);
        document.body.removeChild(div);
        return _cssConstants["default"].safeAreaBottomDivisor ? calculatedPadding / _cssConstants["default"].safeAreaBottomDivisor : calculatedPadding;
      }

      if (CSS.supports('padding-bottom: env(safe-area-inset-bottom)')) {
        var _div2 = document.createElement('div');

        _div2.style.paddingBottom = 'env(safe-area-inset-top)';
        document.body.appendChild(_div2);

        var _calculatedPadding2 = (0, _parseInt2["default"])(window.getComputedStyle(_div2).paddingBottom, 10);

        document.body.removeChild(_div2);
        return _cssConstants["default"].safeAreaBottomDivisor ? _calculatedPadding2 / _cssConstants["default"].safeAreaBottomDivisor : _calculatedPadding2;
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "loadStopCallBack", function (src) {
      if (_DeviceInfoHelper["default"].isAndroid()) {
        _this.setState({
          isLoading: false
        });
      }

      _this.props.setBackButtonFunc(function () {
        return _this.hideWebViewAndGoBack(src);
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "hideWebViewAndGoBack", /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(sourceUrl) {
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (_this.urlRef) {
                  _this.urlRef.executeScript({
                    code: 'window.location.href'
                  }, /*#__PURE__*/function () {
                    var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(params) {
                      var location, locationSubstring, sourceUrlSubstring;
                      return _regenerator["default"].wrap(function _callee7$(_context7) {
                        while (1) {
                          switch (_context7.prev = _context7.next) {
                            case 0:
                              location = params && params.length > 0 ? params[0] : null;
                              locationSubstring = location.split('.de');
                              sourceUrlSubstring = sourceUrl.split('.de');

                              if (!(location === sourceUrl || _config["default"].alwaysCloseWebViewOnBackButton || locationSubstring[1] && sourceUrlSubstring[1] && locationSubstring[1] === sourceUrlSubstring[1])) {
                                _context7.next = 11;
                                break;
                              }

                              _this.urlRef.hide();

                              _context7.next = 7;
                              return (0, _TimeoutHelper.timeout)(200);

                            case 7:
                              _this.urlRef.close();

                              _this.props.closeTile();

                              _context7.next = 12;
                              break;

                            case 11:
                              _this.urlRef.executeScript({
                                code: 'window.history.back()'
                              }, function (backparams) {
                                console.log(backparams);
                              });

                            case 12:
                            case "end":
                              return _context7.stop();
                          }
                        }
                      }, _callee7);
                    }));

                    return function (_x5) {
                      return _ref8.apply(this, arguments);
                    };
                  }());
                }

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function (_x4) {
        return _ref7.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getMessage", function (message) {
      var _messageToUse$data;

      console.log('getMessage', message);
      var messageHandler = _this.props.messageHandler;
      var messageToUse = typeof message === 'string' ? JSON.parse(message) : message;

      if (messageToUse === null || messageToUse === void 0 ? void 0 : (_messageToUse$data = messageToUse.data) === null || _messageToUse$data === void 0 ? void 0 : _messageToUse$data.command) {
        _this.onReceiveMessage(null, messageToUse);
      }

      console.log('INFO', 'DrupalUrlNugget.getMessage (from webview)', (0, _stringify["default"])(message), messageHandler ? 'has messageHandler' : 'ignored');
      if (messageHandler) messageHandler(message.data);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "showWebViewOverlay", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
      var closeTile, nugget, insetTop, top, scrollFrame, src, width, safeAreaHeight, height;
      return _regenerator["default"].wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _this.webviewShowing = true;
              closeTile = _this.props.closeTile;
              nugget = _this.getNugget(_this.props, _this.state);
              insetTop = _DeviceInfoHelper["default"].isiOS() ? _this.getInsetTop() : 0;
              top = _cssConstants["default"].navBarHeight + insetTop;
              scrollFrame = document.getElementsByClassName('scrollFrame')[0];
              src = _this.getIframeSrc(nugget);

            case 7:
              if (!(src === null)) {
                _context9.next = 13;
                break;
              }

              _context9.next = 10;
              return (0, _TimeoutHelper.timeout)(100);

            case 10:
              src = _this.getIframeSrc(nugget);
              _context9.next = 7;
              break;

            case 13:
              if (scrollFrame) {
                width = scrollFrame.offsetWidth;
                safeAreaHeight = _DeviceInfoHelper["default"].isiOS() ? _this.getInsetBottom() : 0;
                height = _config["default"].hideBottomBarInWebView ? scrollFrame.offsetHeight + _cssConstants["default"].bottomBarHeight + safeAreaHeight : scrollFrame.offsetHeight;
                console.log('safeAreaHeight', safeAreaHeight, scrollFrame.offsetHeight, _cssConstants["default"].bottomBarHeight, height);
                _this.urlRef = cordova.InAppBrowser.open(src, '_blank', "toolbar=no,location=no,usewkwebview=yes,originx=0,originy=".concat(top, ",width=").concat(width, ",height=").concat(height, ",zoom=no")); // TODO this event listeners are never removed

                console.log('showWebViewOverlay3', _this.urlRef);

                _this.urlRef.addEventListener('loadstop', function () {
                  return _this.loadStopCallBack(src);
                });

                _this.urlRef.addEventListener('message', function (message) {
                  return _this.getMessage(message);
                });

                if (_DeviceInfoHelper["default"].isAndroid()) {
                  _this.urlRef.addEventListener('exit', function () {
                    return closeTile();
                  });
                }
              }

            case 14:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    })));
    _this.state = _objectSpread({
      translatedSrc: null,
      waitingForActivation: false,
      currentGeoLocation: null,
      initialized: false,
      srcHead: null,
      srcBody: null,
      isLoading: true,
      // isLoading: false,
      showBePatientText: false
    }, _this.state); // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor

    _this.active = true;
    _this.isIframeWithMessagingLoaded = false;
    _this.onBackStack = null;
    props.registerNugget(props.id, _UrlNugget["default"].CLASS, _this.getDomId(), props.inSwipeContainer || props.inGalleryContainer || props.inListContainer);
    _this.backTimer = null;
    _this.iframeLoadingTimer = null;
    _this.bePatientDialogCloseFn = null;
    _this.urlRef = null;
    _this.webviewShowing = false;
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalUrlNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.TC_SETTINGS_OPEN]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalUrlNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (_config["default"].isSafetureApp) {
        this.getCurrentGeoLocation();

        _GeolocationHelper["default"].watchGeolocation(GEO_WATCH_ID);
      }

      var _this$props = this.props,
          goUpFunc = _this$props.goUpFunc,
          id = _this$props.id,
          inListContainer = _this$props.inListContainer,
          setBackButtonFunc = _this$props.setBackButtonFunc;
      this.registerNuggetPosition(id, _UrlNugget["default"].CLASS, this.getDomId());
      var nugget = this.getNugget(this.props, this.state);
      var newState = {};

      if (inListContainer) {
        setBackButtonFunc(goUpFunc);
      }

      (0, _KeyboardHelper.setSoftKeyboardShrinksPage)(false);
      this.getOriginalSrc(nugget).then(function (translatedSrc) {
        newState.translatedSrc = translatedSrc;

        if (nugget.offlineAvailable) {
          _this2.downloadSrc(nugget, id, translatedSrc);
        } else {
          newState.initialized = true;
        }

        if (shouldAddMessageListener(nugget)) {
          _this2.addMessagesListener();

          _this2.startLoadingTimer(nugget);
        } else if (_DeviceInfoHelper["default"].isiOS()) {
          newState.isLoading = false;
        }

        _this2.setState(newState);
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this3 = this;

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalUrlNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      var _this$state = this.state,
          data = _this$state.data,
          waitingForActivation = _this$state.waitingForActivation,
          srcHead = _this$state.srcHead,
          srcBody = _this$state.srcBody;
      var _this$props2 = this.props,
          id = _this$props2.id,
          expanded = _this$props2.expanded,
          location = _this$props2.location;

      if (_config["default"].isSafetureApp && prevProps.location !== location) {
        this.getCurrentGeoLocation(location);
      }

      var nugget = this.getNugget(prevProps, this.state);
      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join('!')), data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join('!')] : nugget.active;

      if (waitingForActivation && active !== this.active) {
        this.setState({
          waitingForActivation: false
        });
      }

      if (!prevProps.expanded && expanded && nugget.openInWebview || nugget.openInWebview && expanded && !this.webviewShowing && _config["default"].forceWebViewOpening) {
        this.showWebViewOverlay();
      }

      if (!nugget.openInWebview) {
        var oldNugget = this.getNugget(prevProps, prevState);
        var newNugget = this.getNugget(this.props, this.state);

        if (oldNugget !== newNugget) {
          this.getOriginalSrc(newNugget).then(function (translatedSrc) {
            _this3.downloadSrc(newNugget, id, translatedSrc);

            if (shouldAddMessageListener(newNugget)) {
              _this3.startLoadingTimer(newNugget);
            }
          });
        }

        if (shouldAddMessageListener(oldNugget) && !shouldAddMessageListener(newNugget)) {
          this.removeMessagesListener();
        } else if (!shouldAddMessageListener(oldNugget) && shouldAddMessageListener(newNugget)) {
          this.addMessagesListener();
        }

        if (prevState.srcHead !== srcHead || prevState.srcBody !== srcBody) {
          this.setIframeContent(srcHead, srcBody, this.getIframeId(id));
        }
      }

      if (prevState.data[_DataStore.DATA_STORE_PATHS.TC_SETTINGS_OPEN] !== data[_DataStore.DATA_STORE_PATHS.TC_SETTINGS_OPEN]) {
        if (data[_DataStore.DATA_STORE_PATHS.TC_SETTINGS_OPEN]) {
          if (this.urlRef) {
            this.urlRef.hide();
          }
        } else {
          if (this.urlRef) {
            this.urlRef.show();
          }
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.urlRef) {
        this.urlRef.hide();
        this.urlRef.close();
      }

      (0, _KeyboardHelper.setSoftKeyboardShrinksPage)(true);
      this.removeMessagesListener();

      if (this.backTimer) {
        clearTimeout(this.backTimer);
        this.backTimer = null;
      }

      if (this.iframeLoadingTimer) {
        clearTimeout(this.iframeLoadingTimer);
        this.iframeLoadingTimer = null;
      }

      if (_config["default"].isSafetureApp) {
        _GeolocationHelper["default"].clearWatchGeolocation(GEO_WATCH_ID);
      }

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalUrlNugget.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "addMessagesListener",
    value: function addMessagesListener() {
      console.log('adding KesiTools message listener');
      window.addEventListener('message', this.onReceiveMessage);
    }
  }, {
    key: "removeMessagesListener",
    value: function removeMessagesListener() {
      window.removeEventListener('message', this.onReceiveMessage);
    }
  }, {
    key: "startLoadingTimer",
    value: function startLoadingTimer(nugget) {
      var _this4 = this;

      // KesiTools currently not working for offline pages
      if (!nugget.offlineAvailable) {
        this.iframeLoadingTimer = setTimeout(function () {
          _this4.setState({
            showBePatientText: true
          });

          _this4.startSecondLoadingTimer();
        }, IFRAME_LOADING_TIME_1);
      }
    }
  }, {
    key: "startSecondLoadingTimer",
    value: function startSecondLoadingTimer() {
      var _this5 = this;

      this.iframeLoadingTimer = setTimeout(function () {
        if (_this5.bePatientDialogCloseFn) {
          _this5.bePatientDialogCloseFn();
        }

        _NavigationManagerCordova["default"].goBack();

        _this5.bePatientDialogCloseFn = (0, _MuiAlertHelper.showAlertWithOptions)({
          message: (0, _DrupalUrlNuggetStrings.getString)('IFRAME_CONTENT_NOT_AVAILABLE_MESSAGE'),
          title: (0, _DrupalUrlNuggetStrings.getString)('IFRAME_CONTENT_NOT_AVAILABLE_TITLE'),
          showCloseButton: false
        });
      }, IFRAME_LOADING_TIME_2);
    }
  }, {
    key: "sendCommandToWebview",
    value: function sendCommandToWebview(command) {
      var webview = this.urlRef;
      console.log('sendCommandToWebview', webview);

      if (webview) {
        console.log('sendCommandToWebview', command);
        webview.executeScript({
          code: "const messageEvent = new window.CustomEvent('message', {detail: ".concat((0, _stringify["default"])(command), "}); window.dispatchEvent(messageEvent);") // save in localStore,

        }, function (result) {
          return console.log('sendCommandToWebview result', result);
        });
      }
    }
  }, {
    key: "sendCommandToIframe",
    value: function sendCommandToIframe(command) {
      var iframe = document.getElementById(this.getIframeId());
      console.log('sendCommandToIframe', iframe);

      if (iframe) {
        console.log('sendCommandToIframe', command);
        iframe.contentWindow.postMessage(command, '*');
      }
    }
  }, {
    key: "setIframeContent",
    value: function setIframeContent(srcHead, srcBody, iframeId) {
      var elem = document.getElementById(iframeId);

      if (elem) {
        elem.contentDocument.head.innerHTML = srcHead;
        elem.contentDocument.body.innerHTML = srcBody;
        this.setState({
          isLoading: false
        });
      }
    }
  }, {
    key: "downloadSrc",
    value: function () {
      var _downloadSrc = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(nugget, id, src) {
        var localFilename, pathOnDisk, oldText, _this$parseHtml, head, body, updatedFilename, updatedPathOnDisk, newText, parsed, newHead, newBody, updatedOnDisk, _newText, _this$parseHtml2, _head, _body;

        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(src && nugget.offlineAvailable)) {
                  _context10.next = 56;
                  break;
                }

                // check if it already exists
                localFilename = "".concat(id, ".html");
                _context10.next = 4;
                return _DownloadHelper["default"].getLocalFilename(localFilename, nugget.maxAgeIfOffline);

              case 4:
                pathOnDisk = _context10.sent;
                console.log('filename - path on disk', pathOnDisk);

                if (!pathOnDisk) {
                  _context10.next = 37;
                  break;
                }

                _context10.t0 = _FileReaderWriterWrapper["default"];
                _context10.next = 10;
                return _CordovaFileHelper["default"].getFileEntry(localFilename, _CordovaFileHelper.LOCAL_FILENAMES.DOWNLOAD_FOLDER);

              case 10:
                _context10.t1 = _context10.sent;
                _context10.next = 13;
                return _context10.t0.readFileAsText.call(_context10.t0, _context10.t1);

              case 13:
                oldText = _context10.sent;
                _this$parseHtml = this.parseHtml(oldText), head = _this$parseHtml.head, body = _this$parseHtml.body;
                this.setState({
                  srcHead: head,
                  srcBody: body,
                  initialized: true
                });
                updatedFilename = "".concat(localFilename, ".updated");
                _context10.next = 19;
                return _DownloadHelper["default"].download(src, updatedFilename, -1);

              case 19:
                updatedPathOnDisk = _context10.sent;

                if (!updatedPathOnDisk) {
                  _context10.next = 35;
                  break;
                }

                _context10.t2 = _FileReaderWriterWrapper["default"];
                _context10.next = 24;
                return _CordovaFileHelper["default"].getFileEntry(updatedFilename, _CordovaFileHelper.LOCAL_FILENAMES.DOWNLOAD_FOLDER);

              case 24:
                _context10.t3 = _context10.sent;
                _context10.next = 27;
                return _context10.t2.readFileAsText.call(_context10.t2, _context10.t3);

              case 27:
                newText = _context10.sent;

                if (!(oldText !== newText)) {
                  _context10.next = 35;
                  break;
                }

                parsed = this.parseHtml(newText);
                newHead = parsed.head;
                newBody = parsed.body;
                this.setState({
                  srcHead: newHead,
                  srcBody: newBody
                });
                _context10.next = 35;
                return _CordovaFileHelper["default"].moveFile("".concat(_CordovaFileHelper.LOCAL_FILENAMES.DOWNLOAD_FOLDER, "/").concat(updatedFilename), "".concat(_CordovaFileHelper.LOCAL_FILENAMES.DOWNLOAD_FOLDER, "/").concat(localFilename), true);

              case 35:
                _context10.next = 54;
                break;

              case 37:
                _context10.next = 39;
                return _DownloadHelper["default"].download(src, localFilename);

              case 39:
                updatedOnDisk = _context10.sent;

                if (!updatedOnDisk) {
                  _context10.next = 52;
                  break;
                }

                _context10.t4 = _FileReaderWriterWrapper["default"];
                _context10.next = 44;
                return _CordovaFileHelper["default"].getFileEntry(localFilename, _CordovaFileHelper.LOCAL_FILENAMES.DOWNLOAD_FOLDER);

              case 44:
                _context10.t5 = _context10.sent;
                _context10.next = 47;
                return _context10.t4.readFileAsText.call(_context10.t4, _context10.t5);

              case 47:
                _newText = _context10.sent;
                _this$parseHtml2 = this.parseHtml(_newText), _head = _this$parseHtml2.head, _body = _this$parseHtml2.body;
                this.setState({
                  srcHead: _head,
                  srcBody: _body,
                  initialized: true
                });
                _context10.next = 54;
                break;

              case 52:
                _NavigationManagerCordova["default"].goBack();

                (0, _MuiAlertHelper.showAlertWithOptions)({
                  message: (0, _DrupalUrlNuggetStrings.getString)('IFRAME_CONTENT_NOT_AVAILABLE_MESSAGE'),
                  title: (0, _DrupalUrlNuggetStrings.getString)('IFRAME_CONTENT_NOT_AVAILABLE_TITLE'),
                  showCloseButton: false
                });

              case 54:
                _context10.next = 57;
                break;

              case 56:
                this.setState({
                  initialized: true
                });

              case 57:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function downloadSrc(_x6, _x7, _x8) {
        return _downloadSrc.apply(this, arguments);
      }

      return downloadSrc;
    }()
  }, {
    key: "downloadFile",
    value: function () {
      var _downloadFile = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(callbackId, url, localFilename, reload) {
        var fullPath;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;

                if (!(url && localFilename)) {
                  _context11.next = 8;
                  break;
                }

                _context11.next = 4;
                return _DownloadHelper["default"].download(url, localFilename, reload ? -1 : 0);

              case 4:
                fullPath = _context11.sent;
                this.sendCommandToIframe({
                  command: 'fileDownloadedSuccess',
                  callbackId: callbackId,
                  fullPath: fullPath
                });
                _context11.next = 9;
                break;

              case 8:
                this.sendCommandToIframe({
                  command: 'fileDownloadedError',
                  callbackId: callbackId,
                  error: 'missing parameter url or localfilname'
                });

              case 9:
                _context11.next = 15;
                break;

              case 11:
                _context11.prev = 11;
                _context11.t0 = _context11["catch"](0);
                console.error('error downloading file in DrupalUrlNugget:', _context11.t0);
                this.sendCommandToIframe({
                  command: 'fileDownloadedError',
                  callbackId: callbackId,
                  error: _context11.t0
                });

              case 15:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 11]]);
      }));

      function downloadFile(_x9, _x10, _x11, _x12) {
        return _downloadFile.apply(this, arguments);
      }

      return downloadFile;
    }()
  }, {
    key: "getNugget",

    /**
     * @returns {UrlNugget}
     */
    value: function getNugget(props, state) {
      var nuggetId = props.id;
      var content = state.content;
      return content ? content[nuggetId] : null;
    }
  }, {
    key: "getOriginalSrc",
    value: function () {
      var _getOriginalSrc = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(nugget) {
        var flexLink, src;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                flexLink = this.props.flexLink;
                src = flexLink ? flexLink : nugget ? nugget.src : '';

                if (!src) {
                  _context12.next = 8;
                  break;
                }

                _context12.next = 5;
                return this.replaceWildcards(src);

              case 5:
                _context12.t0 = _context12.sent;
                _context12.next = 9;
                break;

              case 8:
                _context12.t0 = '';

              case 9:
                return _context12.abrupt("return", _context12.t0);

              case 10:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getOriginalSrc(_x13) {
        return _getOriginalSrc.apply(this, arguments);
      }

      return getOriginalSrc;
    }()
  }, {
    key: "getIframeSrc",
    value: function getIframeSrc(nugget) {
      var _this$state2 = this.state,
          initialized = _this$state2.initialized,
          translatedSrc = _this$state2.translatedSrc;

      if (!initialized || nugget.offlineAvailable) {
        return null;
      }

      return translatedSrc;
    }
  }, {
    key: "callDefaultBack",
    value: function callDefaultBack() {
      var onBackDefault = (0, _ArrayHelper.getSecondLastElement)(this.onBackStack);

      if (onBackDefault) {
        onBackDefault();
      }
    }
  }, {
    key: "getDataStorePathForKey",
    value: function getDataStorePathForKey(key) {
      if (key.indexOf('.') > 0) {
        return key;
      }

      return "".concat(_DataStore.DATA_STORE_PATHS.IFRAME_DATA, ".").concat(key);
    }
  }, {
    key: "parseHtml",
    value: function parseHtml(htmlText) {
      try {
        var head = htmlText.split('<head>')[1].split('</head>')[0];
        var body = htmlText.split('<body>')[1].split('</body>')[0];
        return {
          head: head,
          body: body
        };
      } catch (error) {
        console.error('error parsing html', error);
      }

      return {
        head: null,
        body: null
      };
    }
  }, {
    key: "sendGeolocationToIframe",
    value: function () {
      var _sendGeolocationToIframe = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13() {
        var _this6 = this;

        var onError, geolocation;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                onError = function onError(error) {
                  _this6.sendCommandToIframe({
                    command: 'geolocationFail',
                    error: {
                      code: error.code,
                      message: error.message
                    }
                  });
                };

                try {
                  geolocation = _GeolocationHelper["default"].getCurrentPositionImmediately() || this.state.currentGeoLocation;

                  if (geolocation) {
                    this.sendCommandToIframe({
                      command: 'geolocation',
                      location: geolocation
                    });
                  } else {
                    onError(new Error('No geolocation available'));
                  }
                } catch (error) {
                  onError(error);
                }

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function sendGeolocationToIframe() {
        return _sendGeolocationToIframe.apply(this, arguments);
      }

      return sendGeolocationToIframe;
    }()
  }, {
    key: "replaceWildcards",
    value: function () {
      var _replaceWildcards = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(src) {
        var currentGeoLocation, languageObj, languageCode, policyNumber, instanceId;
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                currentGeoLocation = this.state.currentGeoLocation;

                if (src.indexOf('<Location>') >= 0) {
                  if (currentGeoLocation) {
                    src = src.replace(/<Location>/g, window.encodeURIComponent("@".concat(currentGeoLocation.latitude, ",").concat(currentGeoLocation.longitude)));
                  } else {
                    src = src.replace(/<Location>/g, window.encodeURIComponent('n/a'));
                  }
                }

                languageObj = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_LANGUAGE); // duplicate language code (de) to match expected format (deDE)
                // TODO: Fix the duplication of the language code

                languageCode = languageObj && languageObj.languageCode ? "".concat(languageObj.languageCode).concat(languageObj.languageCode.toUpperCase()) : window.navigator.language; // remove country code from policy number if it is a test policy number for a presentation on 9/apr/2018

                policyNumber = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_POLICY_NUMBER);
                _context14.next = 7;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 7:
                instanceId = _context14.sent;
                return _context14.abrupt("return", src // TODO: replace it with current language from data store if there is one
                .replace(/<DeuWoOAuth2Defaults>/g, 'response_type=code&response_mode=query&scope=openid%20email&client_id=c838b71e-52e4-4725-95a0-a6d345451fd4').replace(/<InstanceId>/g, window.encodeURIComponent(instanceId || '')).replace(/<Language>/g, window.encodeURIComponent(languageCode || _config["default"].supportedLanguages[0])).replace(/<Tariff>/g, window.encodeURIComponent(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_TARIFF) || '')).replace(/<PolicyNumber>/g, window.encodeURIComponent(policyNumber)).replace(/<PolicyNumberWithoutCountryCode>/g, window.encodeURIComponent(policyNumber ? policyNumber.substring(2) : 'n/a')).replace(/<AgencyKey>/g, window.encodeURIComponent(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_AGENCY))));

              case 9:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function replaceWildcards(_x14) {
        return _replaceWildcards.apply(this, arguments);
      }

      return replaceWildcards;
    }()
  }, {
    key: "setIframeLoaded",
    value: function () {
      var _setIframeLoaded = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15() {
        var objToSend;
        return _regenerator["default"].wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (this.isIframeWithMessagingLoaded) {
                  _context15.next = 12;
                  break;
                }

                this.isIframeWithMessagingLoaded = true; // send command to iframe to let the kesi-iframe script know that it lives in an iframe

                objToSend = {
                  command: 'frameLoaded',
                  os: _DeviceInfoHelper["default"].getOS(),
                  savedValues: this.getSavedValuesForIframe()
                };
                this.sendCommandToIframe(objToSend); // set close callback as soon as this nugget is visible

              case 4:
                if (this.props.expanded) {
                  _context15.next = 9;
                  break;
                }

                _context15.next = 7;
                return (0, _TimeoutHelper.timeout)(200);

              case 7:
                _context15.next = 4;
                break;

              case 9:
                _context15.next = 11;
                return (0, _TimeoutHelper.timeout)(100);

              case 11:
                this.onBackStack = this.props.setBackButtonFunc(this.onBack, true);

              case 12:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function setIframeLoaded() {
        return _setIframeLoaded.apply(this, arguments);
      }

      return setIframeLoaded;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          contentPathArray = _this$props3.contentPathArray,
          id = _this$props3.id,
          inGalleryContainer = _this$props3.inGalleryContainer,
          inListContainer = _this$props3.inListContainer,
          inSwipeContainer = _this$props3.inSwipeContainer,
          renderIcon = _this$props3.renderIcon;
      var _this$state3 = this.state,
          data = _this$state3.data,
          isLoading = _this$state3.isLoading,
          showBePatientText = _this$state3.showBePatientText;
      var nugget = this.getNugget(this.props, this.state);
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(id, ".").concat(contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][id][contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active; // if (!active && feature === null) {
      //   return null
      // }

      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';
      var src = this.getIframeSrc(nugget);

      if (!nugget.offlineAvailable && !src) {
        return null;
      }

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "urlContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: inSwipeContainer || inListContainer || inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, _config["default"].showNuggetIcons ? renderIcon(nugget) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_Nugget["default"].container, " ").concat(innerClassNames)
      }, isAuthor && !nugget.isPublished && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10px',
          color: 'red'
        }
      }, "Content unver\xF6ffentlicht"), nugget.openInWebview ? null : /*#__PURE__*/_react["default"].createElement("iframe", {
        allow: "geolocation" // when src changes -> key changes -> different component -> equals iFrame reload ### no key -> no reload
        ,
        key: this.getIframeId(),
        id: this.getIframeId() // TODO: Check if we need to turn off the sandbox for ERGO Schadensformualar in Travel & Care
        // sandbox={`allow-forms allow-pointer-lock allow-popups allow-scripts ${nugget.offlineAvailable ? 'allow-same-origin' : ''}`}
        ,
        src: src,
        className: "UrlNugget_".concat(id, " ").concat(_DrupalUrlNugget["default"].withBottomBar),
        style: _config["default"].showLectureSidebar ? {
          padding: '15px',
          opacity: isLoading ? 0 : 1
        } : {
          opacity: isLoading ? 0 : 1,
          overflow: 'scroll',
          WebkitOverflowScrolling: 'touch',
          width: '1px',
          minWidth: '100%'
        },
        width: "100%",
        height: "90%",
        frameBorder: "0",
        onLoad: this.onLoaded
      }), isLoading && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          top: 50,
          margin: '150px 30px'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'absolute',
          top: 80,
          textAlign: 'center',
          width: '100%',
          left: 0
        }
      }, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'absolute',
          top: 140,
          width: '80%',
          left: '50%',
          transform: 'translateX(-50%)'
        }
      }, showBePatientText ? (0, _DrupalUrlNuggetStrings.getString)('BE_PATIENT_MESSAGE') : null))));
    }
  }]);
  return DrupalUrlNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalUrlNugget;
DrupalUrlNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  region: _propTypes["default"].string,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  flexLink: _propTypes["default"].string,
  location: _propTypes["default"].object,
  setTitle: _propTypes["default"].func,
  setBackButtonFunc: _propTypes["default"].func,
  expanded: _propTypes["default"].bool.isRequired,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  messageHandler: _propTypes["default"].func,
  // from inAppBrowser only
  renderIcon: _propTypes["default"].func.isRequired
};
DrupalUrlNugget.defaultProps = {
  id: null
};